import { render, staticRenderFns } from "./commissionSetting.vue?vue&type=template&id=2a6b0b8d"
import script from "./commissionSetting.vue?vue&type=script&lang=js"
export * from "./commissionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports